import RegisterModal from './Register.react'

export default RegisterModal
